import axios from 'axios';
import * as types from './actionTypes';
import { handleError } from '../errors/handleError';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error);

    dispatch({
        type,
        error: errorMessage,
    });
}

export function changeProjects() {
    return {
        type: types.CHANGE_PROJECTS,
    };
}

export function getProject(projectId) {
    return function (dispatch) {
        dispatch({ type: types.GET_PROJECT_PENDING });
        return axios
            .get(`${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}/project?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}`)
            .then((response) => {
                dispatch({
                    type: types.GET_PROJECT_SUCCESS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_PROJECT_FAILED);
            });
    };
}

export function getLiveProjectConfig(cid) {
    return function (dispatch) {
        return axios
            .get(`${window.GENESIS_CMS_API_URL}/v2/projects/config?cid=${cid}&forCMS=true`)
            .then((response) => {
                dispatch({
                    type: types.GET_LIVE_CONFIG,
                    payload: response.data.data,
                });
            })
            .catch(() => {
            });
    };
}

export function getProjects() {
    return function (dispatch) {
        dispatch({
            type: types.GET_PROJECTS_PENDING,
        });
        return axios
            .get(`${window.GENESIS_CMS_API_URL}/v2/projects`, {
                params: {
                    sessionId: localStorage.getItem('SessionId'),
                    token: localStorage.getItem('AuthToken'),
                    includeLatestVersion: true,
                },
            })
            .then((response) => {
                dispatch({
                    type: types.GET_PROJECTS_SUCCESS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_PROJECTS_FAILED);
            });
    };
}

export function createProject(name, isUnity) {
    let projData = {projectName: name, isUnity: isUnity}; 

    return function (dispatch) {
        dispatch({
            type: types.CREATE_PROJECT_PENDING,
        });
        const createProjectInApi = () => {
            return axios({
                url: `${window.GENESIS_CMS_API_URL}/v2/projects/create?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}`,
                data: projData,
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
            });
        };

        const dispatchProjectAction = (response) => {
            dispatch({
                type: types.CREATE_PROJECT_SUCCESS,
                payload: {
                    data: response.data.data,
                    ids: {
                        newProjectId: response.data.data.id,
                    },
                },
            });
        };

        const handleErrorFn = (error) => {
            errorHandler(dispatch, error.response, types.CREATE_PROJECT_FAILED);
        };

        return createProjectInApi()
            .then(dispatchProjectAction)
            .catch(handleErrorFn);
    };
}
